import MarketingLayout from '../layouts/MarketingLayout.jsx'
import SEOHead from '../components/SEOHead.jsx'
import PricingCard from '../components/PricingCard.jsx'
import FAQAccordion from '../components/FAQAccordion.jsx'
import CTAButton from '../components/CTAButton.jsx'

const PLANS = [
  {
    emoji: '🏁',
    name: 'Bêta',
    price: 'Gratuit',
    badge: 'Maintenant',
    highlight: true,
    description: "Disponible aujourd'hui — toutes les fonctionnalités sans restriction.",
    features: [
      'Création de quiz illimitée',
      'Génération par IA incluse',
      'Toutes les fonctionnalités de course',
      'Synthèse pédagogique complète',
      "Jusqu'à 30 joueurs par partie",
      'Bibliothèque communauté',
    ],
    cta: 'Créer un compte gratuit',
    ctaTo: '/login',
    available: true,
  },
  {
    emoji: '🚗',
    name: 'Découverte',
    price: 'Gratuit',
    badge: 'Post-bêta',
    highlight: false,
    description: 'Pour découvrir KartQuiz et animer des parties avec la communauté.',
    features: [
      'Quiz de la communauté',
      'Animation de parties illimitée',
      'Synthèse pédagogique de base',
      "Jusqu'à 30 joueurs par partie",
    ],
    cta: 'À venir',
    available: false,
  },
  {
    emoji: '🏎️',
    name: 'Pro',
    price: 'À bas prix',
    badge: 'Post-bêta',
    highlight: false,
    description: 'Pour créer tes propres quiz et accéder à toutes les fonctionnalités avancées.',
    features: [
      'Tout ce qui est dans Découverte',
      'Création de quiz personnalisés illimitée',
      'Génération IA illimitée',
      'Synthèse pédagogique avancée',
      'Joueurs illimités',
    ],
    cta: 'À venir',
    available: false,
  },
]

const FAQ_PRICING = [
  {
    q: 'Y aura-t-il toujours un plan gratuit ?',
    a: "Oui. Un plan Découverte gratuit sera maintenu même après la fin de la bêta. Il permettra d'animer des parties avec les quiz de la communauté. La création de quiz personnalisés et la génération IA seront réservées au plan Pro.",
  },
  {
    q: 'Les comptes bêta auront-ils une réduction à vie ?',
    a: 'Les comptes créés pendant la bêta auront un avantage de fidélité lors du passage au plan Pro. Les modalités exactes seront communiquées avant la fin de la bêta.',
  },
  {
    q: 'Les établissements peuvent-ils avoir un tarif groupé ?',
    a: "Ce n'est pas encore proposé, mais c'est dans la roadmap. Écris-nous à contact@kartquiz.fr si tu veux être contacté en priorité pour les offres établissements.",
  },
  {
    q: 'Comment résilier ?',
    a: "Pendant la bêta, il n'y a rien à résilier : aucun abonnement, aucune carte bancaire. Après la bêta, la résiliation sera accessible depuis ton espace profil, sans engagement.",
  },
]

export default function PricingPage() {
  return (
    <MarketingLayout>
      <SEOHead
        title="Tarifs KartQuiz : bêta gratuite, freemium à venir"
        description="Pendant la bêta, tout est gratuit. Voici les tarifs à venir, en toute transparence."
        canonical="/tarifs"
      />

      {/* Hero */}
      <section className="bg-[#F8FAFC] py-20 md:py-28 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display font-semibold text-4xl md:text-5xl text-kart-night mb-6">
            Tarifs KartQuiz
          </h1>
          <p className="text-slate-600 text-xl">
            Pendant la bêta, tout est gratuit. Voici à quoi ressembleront les tarifs ensuite — annoncé en toute transparence.
          </p>
        </div>
      </section>

      {/* Plans */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start mt-4">
            {PLANS.map(plan => (
              <PricingCard key={plan.name} plan={plan} />
            ))}
          </div>
        </div>
      </section>

      {/* Promesse de transparence */}
      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-2xl mx-auto px-6">
          <div className="bg-kart-blue/5 border border-kart-blue/20 rounded-2xl p-8 text-center">
            <div className="text-3xl mb-4">🤝</div>
            <h2 className="font-display font-semibold text-xl text-kart-night mb-3">
              Notre engagement envers les early adopters
            </h2>
            <p className="text-slate-600">
              Pendant la bêta, tu profites de toutes les fonctionnalités. Quand le modèle freemium sera lancé, les comptes bêta auront un avantage de fidélité — on tient au respect des early adopters.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Tarifs */}
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="font-display font-semibold text-2xl md:text-3xl text-kart-night mb-10 text-center">
            Questions sur les tarifs
          </h2>
          <div className="bg-[#F8FAFC] rounded-2xl border border-slate-200 px-8 py-2">
            <FAQAccordion items={FAQ_PRICING} />
          </div>
        </div>
      </section>

      {/* CTA final */}
      <section className="py-20 bg-kart-night text-white text-center">
        <div className="max-w-2xl mx-auto px-6 space-y-6">
          <h2 className="font-display font-semibold text-3xl">Commence gratuitement, maintenant.</h2>
          <p className="text-slate-300 text-lg">
            Aucune carte bancaire. Aucun engagement. Toutes les fonctionnalités.
          </p>
          <CTAButton to="/login" size="lg">Créer un compte gratuit</CTAButton>
        </div>
      </section>
    </MarketingLayout>
  )
}
